import axiosInstance from '../axiosInterceptor/axiosInstance'

const getSingleTeam = async (orgId, teamId) => {
  const url = `v1/orgs/${orgId}/teams/${teamId}`
  const response = await axiosInstance.get(url)
  return response?.data
}

export default getSingleTeam
